import { ReactElement } from 'react';
import { JobDatasetsContainer } from '../../../../modules/jobs/containers/details/JobDatasets.container';

export const TrainingDetailsDatasetsView = (): ReactElement => <JobDatasetsContainer />;
